<template>
  <div :style="'max-width: ' + sliderWidth + 'px'"
       class="pt-2"
       ref="sliderComponent">
    <fin-multi-slider v-if="showActivePassiveSlider"
                      v-model="activePassiveValues"
                      :enable-cross="false"
                      :valueLabels="summaryLabels"
                      :disabled="true"
                      :showValues="false"
                      :showLabels="true"
                      classDots="dot-capacitor"
                      class="sliderSummary"
                      :processStyle="{height: '0px'}"
                      style="width: 100%"
                      dotSize="10"
                      :options="disabledSliderOptions"
    />

    <!-- TODO use colors and stroke's colors defined in AssetClasses.js -->
    <fin-multi-shapes-collection :fill="shapeColors"
                                 :stroke="shapeStrokeColors"
                                 :full-width="sliderWidth"
                                 :percentages="workingData"
                                 style="margin-bottom: -5px;"
    />

    <fin-multi-slider v-model="workingData"
                      :enable-cross="true"
                      :valueLabels="valueLabels"
                      :styleProcessSlider="'alternateLabels'"
                      :showValues="showWorkingDataValues"
                      :showLabels="showWorkingDataLabels"
                      wrapperClass="valueSlider"
                      :style="{minHeight: showWorkingDataLabels ? '160px' : 0, maxWidth: sliderWidth + 'px'}"
                      :processStyle="{backgroundColor: $finColors.primaryDark}"
                      :disabled="disabled"
                      classDots="dot-round"
                      class="sliderValues"
                      @change="$emit('change')"
                      :options="valueSliderOptions"
    />
  </div>
</template>

<script>
import FinMultiSlider from '@/components/common/MultiSlider/index'
import FinMultiShapesCollection from '@/components/common/shapes/MultiCollection/index'
import AssetClasses from "@/mocks/AssetClasses"

export default {
  name: 'FinStrategySlider',
  components: {FinMultiShapesCollection, FinMultiSlider},
  props: {
    value: {
      type: Array
    },
    valueLabels: {
      type: Array
    },
    enableCross: {
      type: Boolean
    },
    disabled: {
      /* The slider at the top is always disabled. This property is to enable/disable the slider at the bottom. */
      type: Boolean,
      default: false
    },
    showActivePassiveSlider: {
      type: Boolean,
      default: true
    },
    showWorkingDataLabels: {
      type: Boolean,
      default: true
    },
    showWorkingDataValues: {
      type: Boolean,
      default: true
    },
    processStyleWorkingData: {
      type: String,
      default: "{backgroundColor: '#02073a'}"
    },
    styleDotsWorkingData: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      workingData: this.value,
      adaptedWorkingData: [],
      shapeColors: [
        AssetClasses.items.find(item => item.id === 'SHARE').color,
        AssetClasses.items.find(item => item.id === 'SHARE_ETF').color,
        AssetClasses.items.find(item => item.id === 'CORPORATE_BONDS_ETF').color,
        AssetClasses.items.find(item => item.id === 'GOVERNMENT_BONDS_ETF').color,
        AssetClasses.items.find(item => item.id === 'COMMODITIES_ETF').color
      ],
      shapeStrokeColors: [
        AssetClasses.items.find(item => item.id === 'SHARE').strokeColor,
        AssetClasses.items.find(item => item.id === 'SHARE_ETF').strokeColor,
        AssetClasses.items.find(item => item.id === 'CORPORATE_BONDS_ETF').strokeColor,
        AssetClasses.items.find(item => item.id === 'GOVERNMENT_BONDS_ETF').strokeColor,
        AssetClasses.items.find(item => item.id === 'COMMODITIES_ETF').strokeColor
      ],
      valueSliderOptions: {
        dotOptions: [
          {
            style: {
              backgroundColor: AssetClasses.items.find(item => item.id === 'SHARE').color,
              border: '10px solid #ffffff'
            }
          },
          {
            style: {
              backgroundColor: AssetClasses.items.find(item => item.id === 'SHARE_ETF').color,
              border: '10px solid #ffffff'
            }
          },
          {
            style: {
              backgroundColor: AssetClasses.items.find(item => item.id === 'CORPORATE_BONDS_ETF').color,
              border: '10px solid #ffffff'
            }
          },
          {
            style: {
              backgroundColor: AssetClasses.items.find(item => item.id === 'GOVERNMENT_BONDS_ETF').color,
              border: '10px solid #ffffff'
            }
          },
          {
            disabled: true,
            style: {
              backgroundColor: AssetClasses.items.find(item => item.id === 'COMMODITIES_ETF').color,
              border: '10px solid #ffffff'
            }
          }
        ]
      },
      disabledSliderOptions: {
        dotOptions: [
          {
            style: {
              backgroundColor: '#ffff',
              borderRadius: '0',
              borderTop: '0px',
              borderBottom: '0px',
              borderRight: '1px solid #99a0a4',
              borderLeft: '1px solid #99a0a4',
              boxShadow: 'none'
            }
          },
          {
            style: {
              backgroundColor: AssetClasses.items.find(item => item.id === 'SHARE_ETF').color
            }
          },
          {
            style: {
              backgroundColor: AssetClasses.items.find(item => item.id === 'CORPORATE_BONDS_ETF').color
            }
          },
          {
            style: {
              backgroundColor: AssetClasses.items.find(item => item.id === 'GOVERNMENT_BONDS_ETF').color
            }
          },
          {
            style: {
              backgroundColor: AssetClasses.items.find(item => item.id === 'COMMODITIES_ETF').color
            }
          }
        ]
      }
    }
  },
  computed: {
    sliderWidth() {
      let width = 750
      if (this.$vuetify.breakpoint.sm) {
        width = window.innerWidth * 75 / 100
      } else if (this.$vuetify.breakpoint.xs) {
        width = window.innerWidth * 65 / 100
      }
      return width
    },
    activePassiveValues() {
      const base = this.workingData[0]
      const res = []
      res[0] = base
      res[1] = 100 - base
      return res
    },
    summaryLabels() {
      const res = []
      res[0] = this.activePassiveValues[0] + '% aktive Investitionen'.toUpperCase()
      res[1] = this.activePassiveValues[1] + '% passive Investitionen'.toUpperCase()
      return res
    }
  },
  watch: {
    workingData() {
      this.$emit('input', this.workingData)
    },
    value() {
      this.workingData = this.value
    }

  }
}
</script>

<style lang="scss" scoped>
.sliderShare {
  margin-bottom: 10px;
}

.sliderSummary, .sliderShare {
  border-right: 1px solid $fin-color-cool-grey;
  border-left: 1px solid $fin-color-cool-grey;

  .vue-slider-rail {
    height: 1px;
    background-color: $fin-color-cool-grey !important;
  }

  .vue-slider-process {
    background: none !important;
  }
}

.sliderValues {
  .vue-slider-rail {
    height: 1px;
  }
}

::v-deep .vue-slider-dot:last-of-type {
  visibility: hidden;
}
</style>
